import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'base-img',
  props: {
    src: null
  },
  setup(__props: any) {

const props = __props as {
  src: string;
}



const imageSrc = computed(() => require(`@/ui-library/assets/${props.src}`));

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createBlock(_component_v_img, { src: _unref(imageSrc) }, null, 8, ["src"]))
}
}

})